import styled from '@emotion/styled'
import { StrikethroughPrice } from 'shop/components/Shop/commonStyles'

export const StyledStrikethroughPrice = styled(StrikethroughPrice)({
  fontSize: '12px',
  fontWeight: 400,
  color: '#8B8B8B'
})
